<script lang="ts">
	//Helpers
	import { isWallDisplay, real_id } from '../../../../../helpers/interface_helpers';
	//Stores
	import { getDeviceSettings, getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	//Svelte hooks
	import { beforeUpdate, onDestroy } from 'svelte';
	//Components
	import ThermostatsInList from './ThermostatsInList.svelte';

	export let device;
	export let variant: 'full' | 'control' | 'extractedMain' = 'full';

	let id = real_id(device.id),
		thermostat;

	$: statusStore = getDeviceStatus(isWallDisplay(device.type) ? device.id : id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(isWallDisplay(device.type) ? device.id : id);
	$: deviceSettings = $settingsStore;

	beforeUpdate(() => {
		const isWallDisplayThermostatShared = isWallDisplay(device.type);
		const deviceRealId = real_id(isWallDisplayThermostatShared ? device.id : id);
		Object.keys(deviceSettings ?? {}).forEach((title) => {
			if (title.includes('thermostat')) {
				//we are getting settings package mostly to get display unit
				if (typeof thermostat === 'undefined') {
					thermostat = deviceSettings[title];
				}
			}
		});
		if (status) {
			Object.keys(status).forEach((title) => {
				if (title.includes('thermostat')) {
					// here we are overriding target_C from settings with it's Status value. doing this because when schedules are active, only status package is updated. From status package we can get target_C
					if (
						typeof thermostat !== 'undefined' &&
						JSON.stringify(thermostat) !== JSON.stringify(status[title])
					) {
						//update thermostat if there are changes from device status
						thermostat = {
							...thermostat,
							...status[title],
						};
					}
				}
			});
		}
	});
	onDestroy(() => {
		//clearing thermostat on destroy. It will be rendered anyway on next rendering
		thermostat = undefined;
	});
</script>

<ThermostatsInList bind:thermostat {device} {variant} />
